module.exports = __webpack_public_path__ + "img/check-email.ce7715c7.png";